<template>
  <div class="d-flex flex-column flex-root" v-if="isAuthenticated">
    <div class="button-open-menu">
      <button class="button-menu-mobile" @click="activeMenuMobile()">
        <img :src="iconOpenMenu">
      </button>
    </div>
    <MenuMobile></MenuMobile>
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>

    <!-- begin::Body -->
    <div class="d-flex flex-row flex-column-fluid page">
      <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid">
        <!-- begin:: Header -->
<!--        <KTHeader></KTHeader>-->
        <!-- end:: Header -->

        <!-- begin:: Content -->
        <div
          id="kt_content"
          class="content d-flex flex-column flex-column-fluid"
        >
        <!--<div
          id="kt_content"
          class="content d-flex flex-column flex-column-fluid"
        > -->
          <!-- begin:: Content Head -->

          <!-- begin:: Content Head -->
          <KTSubheader
            v-if="subheaderDisplay"
            v-bind:breadcrumbs="breadcrumbs"
            v-bind:title="pageTitle"
          />
          <!-- end:: Content Head -->

          <!-- begin:: Content Body -->
          <div class="d-flex flex-column-fluid p-xl-7">
            <div
              :class="{
                'container-fluid': !contentFluid,
                container: contentFluid
              }"
            >
              <transition name="fade-in-up">
                <router-view />
              </transition>
            </div>
          </div>
        </div>
        <KTFooter></KTFooter>
      </div>
    </div>
    <KTScrollTop></KTScrollTop>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeader from "@/view/layout/header/Header.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import Loader from "@/view/content/Loader.vue";
import MenuMobile from "@/view/layout/header/MenuMobile.vue";
import { getTenantCurrent } from "@/core/services/routeTenant.service";

export default {
  name: "Layout",
  components: {
    KTAside,
    KTHeader,
    KTFooter,
    KTSubheader,
    KTStickyToolbar,
    KTScrollTop,
    MenuMobile,
    Loader
  },
  beforeMount() {
    HtmlClass.init(this.layoutConfig());
  },
  beforeRouteEnter(to, from, next) {
    KTUtil.activeMenu();
    return next();
  },
  mounted() {
    // check if current user is authenticated
    if (!this.isAuthenticated) {
      // get tenant_dir from current URL
      const tenantDir = getTenantCurrent();
      if (tenantDir) {
        this.$router.push(`/${tenantDir}/login`);
      } else {
        this.$router.push({ name: "login" });
      }
    }

    // Simulate the delay page loading
    setTimeout(() => {
      // Remove page loader after some time
      // this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    }, 2000);
  },
  methods: {
    activeMenuMobile(){
      KTUtil.activeMenu();
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig"
    ]),

    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    iconOpenMenu(){
      return process.env.BASE_URL + 'img/icon-menu.png';
    }
  }
};
</script>
